<script>
    import {getAlerts, getUnviewedAlerts, getWatchs} from "../firestore";
    import {merge, from} from "rxjs"
    import {mergeMap, map, toArray} from "rxjs/operators";
    import {getPercentage, getPercentageFB} from "../utils";
    import {push} from "svelte-spa-router"
    import Switch from '../utils/switch.svelte'

    let currentWatchs = [];

    refreshWatches();

    function refreshWatches() {
        currentWatchs = [];
        getWatchs().subscribe(alert => {
            currentWatchs = [...currentWatchs, alert];
        });
    }

    function editWatch(watchId) {
        push("/alert/" + watchId)
    }

    function deleteWatch(watchId) {
        firebase.firestore().collection("alert_watch").doc(watchId).delete();
        currentWatchs = currentWatchs.filter(watch => watch.id !== watchId);
    }

    function newWatch() {
        push("/alert/new");
    }
</script>

<div class="card">
    <div class="card-body">
        <div class="card-head">
            <h2 class="card-title">Alert watch</h2>
        </div>
        <div class="month-table">
            <div class="table-responsive mt-3">
                <table class="table stylish-table mb-0">
                    <thead>
                    <tr>
                        <th>Equipment</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each currentWatchs as watch (watch.id)}
                        <tr>
                            <td>
                                <div class="d-inline">{watch.sensor.name}</div>
                            </td>
                            <td class="td-actions text-right">
                                <button on:click={() => editWatch(watch.id)} rel="tooltip" class="btn btn-warning btn-round">
                                    <i class="mdi mdi-tooltip-edit"></i>
                                </button>
                                <button on:click={() => deleteWatch(watch.id)} rel="tooltip" class="btn btn-danger btn-round">
                                    <i class="mdi mdi-delete"></i>
                                </button>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
        <button on:click={newWatch} class="btn btn-primary">New</button>
    </div>
</div>
